import React from 'react';
export const FooterSection: React.FC = () => {
  return <footer className="bg-[#0F1F0F] text-[#666] text-center py-[35px] px-5 text-[13px] font-sans leading-[2]" data-id="element-99" data-mp="21fe2eioiyvx0">
      <div className="text-base font-bold text-[#A5D6A7] mb-2 font-serif" data-id="element-100" data-mp="33bc827c82xv7">
        🌿 TIERRA VIVA™
      </div>
      <p data-id="element-101" data-mp="3c9o6uwn8t1yq">
        El sistema de bioconstrucción N°1 para el autoconstructor moderno en
        Argentina y Latinoamérica.
      </p>
      <p data-id="element-102" data-mp="2ol51aovkv3ac">
        Porque construir tu casa natural no debería costarte todos los domingos
        del año.
      </p>

      <hr className="border-none border-t border-[#222] my-5 mx-auto max-w-[400px]" data-id="element-103" data-mp="2kk3042i3oh5q" />

      <p className="flex justify-center gap-5 flex-wrap" data-id="element-104" data-mp="2yay9rh0fb2ad">
        <a href="#" className="text-[#888] no-underline hover:text-[#CCC] transition-colors" data-id="element-105" data-mp="2tj6guztsokh2">
          Política de Privacidad
        </a>
        <a href="#" className="text-[#888] no-underline hover:text-[#CCC] transition-colors" data-id="element-106" data-mp="25skenp6h1uez">
          Términos y Condiciones
        </a>
        <a href="#" className="text-[#888] no-underline hover:text-[#CCC] transition-colors" data-id="element-107" data-mp="20sg2gbcljluk">
          Contacto
        </a>
      </p>

      <p className="mt-2.5 text-[11px] text-[#444] leading-relaxed" data-id="element-108" data-mp="1lf9jpszzawpl">
        © MEGA PACK TIERRA VIVA™ 2026 — Todos los derechos reservados.
        <br data-id="element-109" data-mp="1q71deceflijy" />
        Prohibida la reproducción y redistribución sin autorización expresa.
        <br data-id="element-110" data-mp="1v4b2ts1tlu7s" />
        Este producto es un pack digital educativo. Los resultados varían según
        la aplicación individual.
      </p>

      <br data-id="element-111" data-mp="xk6wfpgtp1b8" />

      <p className="italic text-green-light" data-id="element-112" data-mp="12goxofcy2hit">
        🌿 "La tierra te espera. El sistema ya está listo."
      </p>
    </footer>;
};